import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const ViewportContext = createContext();

// Create a provider component
export const ViewportProvider = ({ children }) => {
    
    const [isMobile, setIsMobile] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {   

        const updateViewport = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;

            // Mobile if width is small OR height is small (for rotated mobile)
            const mobileCondition = width <= 768 || height <= 500;
            const desktopCondition = !mobileCondition;

            setIsMobile(mobileCondition);
            setIsDesktop(desktopCondition);
        };

        updateViewport();

        // Listen for resize events
        window.addEventListener("resize", updateViewport);

        return () => window.removeEventListener("resize", updateViewport);

    }, []);

    return (
        <ViewportContext.Provider value={{ isMobile, isDesktop }}>
            {children}
        </ViewportContext.Provider>
    );
};

// Custom hook to use the ViewportContext
export const useViewport = () => {
    const context = useContext(ViewportContext);
    if (!context) {
        throw new Error('useViewport must be used within a ViewportProvider');
    }
    return context;
};